import { api } from '@/lib/api';
import type {
  IApiResponse,
  IFabricItem,
  IFabricLakehouseSchema,
  IFabricLakehouseTable,
  IFabricTableData,
} from '@skystone/shared';

export const fabricPreviewApi = {
  getWorkspaceItems: async (): Promise<IFabricItem[]> => {
    const result = await api.get<IApiResponse<IFabricItem[]>>('/fabric/browse/items');
    return result.data;
  },

  getLakehouseSchemas: async (lakehouseId: string): Promise<IFabricLakehouseSchema[]> => {
    const result = await api.get<IApiResponse<IFabricLakehouseSchema[]>>(`/fabric/browse/lakehouses/${lakehouseId}/schemas`);
    return result.data;
  },

  getLakehouseTables: async (lakehouseId: string, schemaName?: string): Promise<IFabricLakehouseTable[]> => {
    const query = schemaName ? `?schema=${encodeURIComponent(schemaName)}` : '';
    const result = await api.get<IApiResponse<IFabricLakehouseTable[]>>(`/fabric/browse/lakehouses/${lakehouseId}/tables${query}`);
    return result.data;
  },

  getLakehouseTablePreviewData: async (lakehouseId: string, schemaName: string, tableName: string): Promise<IFabricTableData> => {
    const result = await api.get<IApiResponse<IFabricTableData>>(
      `/fabric/browse/lakehouses/${lakehouseId}/table-preview?schema=${encodeURIComponent(schemaName)}&table=${encodeURIComponent(tableName)}`
    );
    return result.data;
  },
};
